import type { LocaleCatalog } from '../types';

export const zhTW: LocaleCatalog = {
  'consult_prompt.title': '轉接提示音',
  'consult_prompt.help': '固定提示音只產生一次，驗證成功後由平台重複使用。轉接時客戶聽到提示與等候音樂，原客服聽到回鈴；同事加入後恢復三方通話。',
  'consult_prompt.ready': '已就緒，可重複使用',
  'consult_prompt.pending': '尚未準備',
  'consult_prompt.prepare': '產生固定提示音',
  'consult_prompt.confirm': '產生並驗證',
  'consult_prompt.cancel': '取消',
  'consult_prompt.billing': '首次產生依目前管理員帳戶的正常 TTS 規則計費，已有有效資產則直接重複使用；不會在每次轉接時重新合成。不會變更企業客服流程或通話音訊設定。',
  'consult_prompt.reason': '操作原因（至少4個字元）',
  'consult_prompt.failed': '提示音準備失敗，請確認後重試',
  'roles.permission_directory': '權限目錄',
  'roles.permission_column': "權限數量",
  'roles.permission_count': "{count} 項",
  'roles.risk_column': "權限風險等級",
  'roles.risk_explanation': "按此角色擁有的權限統計。數字表示該等級權限數量，不表示帳號出現異常。",
  'roles.risk_count': "{risk} · {count} 項",
  'roles.risk.R0': "基礎資訊",
  'roles.risk.R1': "低風險",
  'roles.risk.R2': "一般風險",
  'roles.risk.R3': "高風險",
  'roles.risk.R4': "最高風險",
  'roles.risk.unknown': "等級待確認",
  'roles.no_permissions': "尚未分配權限",
  'roles.all_permissions': "全部（系統內建）",
  'roles.builtin_risk': "包含全部風險等級",
  'roles.builtin_explanation': "超級管理員擁有系統內建的全部管理員權限，無需逐項勾選。充值等最高風險操作仍須完成目前裝置的身分複核。",
  'roles.template_title': "此處設定的是職位權限範本",
  'roles.template_help': "勾選的變更儲存前不會生效。儲存後，只有已獲此職位授權、帳號正常且授權未到期的管理員才會繼承權限；操作仍受資料範圍與身分複核限制。目前職位授權記錄：{count} 筆。",
  'identity.required': "建立管理員前需要驗證目前身分",
  'identity.steps': "你已有管理員職位權限，但目前裝置尚未完成身分複核。輸入驗證器的 6 位動態碼後，即可搜尋使用者並提交建立申請。",
  'identity.setup': "請先在「登入與安全」登記身分驗證器，完成後回到此處點擊「重新檢查身分」。",
  'identity.verify': "驗證並繼續",
  'identity.recheck': "重新檢查身分",
  'identity.failed': "身分驗證未完成",
  'identity.reason': "建立管理員前完成身分複核",
  'identity.search_failed': "平台使用者搜尋失敗",
  'topup.lost_authenticator': "驗證器遺失時，請聯絡仍可驗證的安全管理員處理重設；若全員均無法驗證，須由系統負責人進行獨立的維運復原，不能繼續走動態碼審批。",
  'topup.security_link': "登入與安全",
  'topup.title': "充值算力",
  'topup.title_user': "為「{name}」充值算力",
  'topup.submit': "確認充值",
  'topup.cancel': "取消",
  'topup.amount': "充值數量",
  'topup.reason': "充值原因（4–500 個字，必填）",
  'topup.checking': "正在檢查身分驗證狀態…",
  'topup.setup_required': "充值前需要登記身分驗證器",
  'topup.setup_steps': "點擊「設定身分驗證器」，輸入登入密碼，用手機驗證器掃描 QR 碼並輸入 6 位動態碼。完成後回到此視窗點擊「已設定，重新檢查」；充值數量與備註會保留。",
  'topup.setup_link': "設定身分驗證器",
  'topup.refresh': "已設定，重新檢查",
  'topup.verify_required': "充值前請驗證目前管理員身分",
  'topup.verify_steps': "輸入手機驗證器目前顯示的 6 位動態碼，再點擊「確認充值」。驗證通過後繼續本次充值，無需離開此頁面。",
  'topup.code': "身分驗證器的 6 位動態碼",
  'topup.failed': "充值未完成",
  'topup.user_required': "請先選擇使用者",
  'topup.amount_required': "請輸入大於或等於 0.01 的充值數量",
  'topup.reason_required': "請填寫 4–500 個字的充值原因",
  'topup.code_required': "請輸入驗證器目前顯示的 6 位數字",
  'topup.success': "算力已充值",
  'topup.reload_failed': "充值已完成，但清單重新整理失敗，請手動重新整理",
  'common.loading': '正在載入…',
  'common.page_loading': '正在載入頁面…',
  'auth.permission_loading': '正在核驗管理員權限…',
  'errors.permission_load_failed': '權限資訊載入失敗',
  'errors.permission_unavailable': '暫時無法讀取管理員權限，請重新核驗。',
  'auth.check_again': '重新核驗',
  'auth.sign_out': '登出',
  'common.language_follow_system': '跟隨系統',
  'common.language_user_selected': '手動選擇',
  'common.language': '語言',
  'common.language_zh_cn': '簡體中文',
  'common.language_zh_tw': '繁體中文',
  'common.language_en_us': 'English',
};
